/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Scan_TitleInputs */

const en_features_scan_title = /** @type {(inputs: Features_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo of a meal`)
};

const pl_features_scan_title = /** @type {(inputs: Features_Scan_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdjęcie posiłku`)
};

/**
* | output |
* | --- |
* | "Photo of a meal" |
*
* @param {Features_Scan_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_scan_title = /** @type {((inputs?: Features_Scan_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Scan_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_scan_title(inputs)
	return en_features_scan_title(inputs)
});